module.exports = __webpack_public_path__ + "static/media/figma.bfc8530d.svg";